import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CalendarCheck, LayoutGrid } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { waLink, GOOGLE_BUSINESS_URL } from "../config";
import { WhatsAppIcon, GoogleIcon } from "./icons";
import AssistantPanel from "./Assistant";

export const FloatingActions = () => {
  const { t } = useLang();
  const [assistantOpen, setAssistantOpen] = useState(false);

  const googleClick = (e) => {
    if (!GOOGLE_BUSINESS_URL) {
      e.preventDefault();
      toast(t.common.soonGoogle);
    }
  };

  return (
    <>
      {/* Desktop / floating cluster */}
      <div className="fixed bottom-24 sm:bottom-6 right-4 sm:right-6 z-[75] flex flex-col items-end gap-3" data-testid="floating-actions">
        <a
          href={GOOGLE_BUSINESS_URL || "#"}
          onClick={googleClick}
          target={GOOGLE_BUSINESS_URL ? "_blank" : undefined}
          rel="noopener noreferrer"
          aria-label="Google"
          data-testid="float-google"
          className="hidden sm:flex h-11 w-11 items-center justify-center rounded-full bg-white text-rosedeep shadow-[0_12px_30px_-10px_rgba(43,27,32,0.35)] ring-1 ring-gold/30 transition-all duration-300 hover:scale-110 hover:bg-blush/50"
        >
          <GoogleIcon className="w-5 h-5" />
        </a>
        <a
          href={waLink(t.waDefault)}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          data-testid="float-whatsapp"
          className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-rosedeep text-white shadow-[0_14px_32px_-8px_rgba(212,122,142,0.75)] ring-1 ring-gold/30 transition-transform duration-300 hover:scale-110"
        >
          <WhatsAppIcon className="w-6 h-6" />
        </a>
        <button
          onClick={() => setAssistantOpen((v) => !v)}
          aria-label={t.assistant.name}
          data-testid="float-assistant"
          className="animate-float-soft relative h-14 w-14 overflow-hidden rounded-full ring-2 ring-rose/70 shadow-[0_16px_38px_-10px_rgba(212,122,142,0.75)] transition-transform duration-300 hover:scale-110"
        >
          <img src="/assets/avatar-assistant.png" alt={t.assistant.name} className="h-full w-full object-cover" />
          <span className="absolute bottom-0.5 right-0.5 h-3.5 w-3.5 rounded-full border-2 border-white bg-emerald-400" />
        </button>
      </div>

      <AssistantPanel open={assistantOpen} onClose={() => setAssistantOpen(false)} />

      {/* Mobile bottom action bar */}
      <nav
        className="fixed inset-x-0 bottom-0 z-[74] grid grid-cols-3 border-t border-gold/20 bg-cream/95 backdrop-blur-md sm:hidden"
        data-testid="mobile-bottom-bar"
        aria-label="Ações rápidas"
      >
        <a
          href={waLink(t.waDefault)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mb-whatsapp"
          className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-bold uppercase tracking-widest text-ink/70"
        >
          <WhatsAppIcon className="w-5 h-5 text-rose" />
          WhatsApp
        </a>
        <Link
          to="/servicos"
          data-testid="mb-services"
          className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-bold uppercase tracking-widest text-ink/70"
        >
          <LayoutGrid className="w-5 h-5 text-rosedeep" />
          {t.nav.services}
        </Link>
        <a
          href={waLink(t.waEval)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mb-book"
          className="flex flex-col items-center gap-1 bg-rosedeep py-2.5 text-[10px] font-bold uppercase tracking-widest text-white"
        >
          <CalendarCheck className="w-5 h-5" />
          {t.nav.book.split(" ")[0]}
        </a>
      </nav>
    </>
  );
};

export default FloatingActions;
